import { useSetLayoutProps } from '@hwm/ui-lib';
import { AppLayoutProps } from '@shared/components/Layout/AppLayout';
import { SiderKeys } from '@shared/components/Sider/Sidebar.utils';
import { useCallback } from 'react';

export const useSidebar = () => {
  const [setLayoutProps, { sidebarState, sidebarSection }] = useSetLayoutProps<AppLayoutProps>();

  const handleSidebarSection = useCallback(
    (section: SiderKeys) => {
      setLayoutProps({
        sidebarSection: section,
      });
    },
    [setLayoutProps]
  );

  const handleSidebarState = useCallback(
    (newState: boolean) => {
      setLayoutProps({ sidebarState: newState });
    },
    [setLayoutProps]
  );
  return {
    sidebarState,
    sidebarSection,
    handleSidebarSection,
    handleSidebarState,
  };
};
